import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classes from './Card.module.css';


const Card = ({ backgroundImage, iconImg, color, iconMargin, dropClass, children }) => {


    const direction = useSelector(state => state.translate.direction);

    return (<div className={`${classes.Card} ${classes[direction]} ${dropClass}`} style={{ backgroundColor: color, backgroundImage: backgroundImage && `url(${backgroundImage})` }}>
        <img className={classes.icon} style={{ marginInlineStart: iconMargin }} src={iconImg} />
        {children}
    </div >)
}

export default Card;
